export default __webpack_public_path__ + "static/media/tune_upwards_banner.b9d9db24.jpg";